webpackJsonp([21810443222662],{

/***/ 1380:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ChangelogOrderBy","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"insertedAt","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-changelog-order-by-997483e5e0672a7463bf.js